import UIError from "../Domain/UIError";
import AuthService from "./authService";

export default class ErrorService {
  static LogUIError(error) {
    const errorData = JSON.stringify(new UIError(error));
    return AuthService.getInstance().CallBackendFunctionPost("/api/Error/LogUIError", errorData);
  }
}
